import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';
import { type FC, memo } from 'react';

const BareInfoIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper viewBox='0 0 16 16' {...props}>
    {}
    <path d='M0 8a8 8 0 118 8 8.009 8.009 0 01-8-8zm1 0a7 7 0 107-7 7.008 7.008 0 00-7 7zm5.393 3.988a.387.387 0 01-.387-.387v-.587a.387.387 0 01.387-.387h.622V8.562h-.637a.387.387 0 01-.388-.387V7.4a.387.387 0 01.388-.387h2.611v3.613h.622a.388.388 0 01.387.387v.587a.387.387 0 01-.387.387l-3.218.001zM7 6V4h2v2H7z' />
  </SvgWrapper>
);
export const InfoIcon = memo(BareInfoIcon);
